<script lang="ts">
	import { fade } from 'svelte/transition';

	const h = 'h-1.5';
</script>

<div
	class="flex-auto flex flex-col gap-2 p-2 items-center justify-center dark:bg-background-dark animate-pulse"
	in:fade={{ duration: 400, delay: 50 }}
>
	<div class="w-full bg-surface/30 dark:bg-surface-dark p-2 flex flex-col gap-2 rounded-md">
		<div class="w-full {h} bg-surface-on/20 dark:bg-surface-dark-on/20"></div>
		<div class="w-full {h} bg-surface-on/20 dark:bg-surface-dark-on/20"></div>
	</div>
	<div class="w-full bg-surface/30 dark:bg-surface-dark p-2 flex flex-col gap-2 rounded-md">
		<div class="w-full {h} bg-surface-on/20 dark:bg-surface-dark-on/20"></div>
		<div class="w-full {h} bg-surface-on/20 dark:bg-surface-dark-on/20"></div>
	</div>
</div>
